<template>
  <button class="k-icon-button">
    <k-icon
      :icon="type"
      class="icon"
    />
  </button>
</template>

<script>
import KIcon from './KIcon.vue';

export default {
  name: "KIconButton",
  props: {
    type: {
      type: String,
      default: '',
      required: true,
      validator: value => ['left1', 'arrow-right'].includes(value)
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  components: {
    KIcon
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

.k-icon-button {
  width: 48px;
  height: 48px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  cursor: pointer;
  transition: all ease 0.2s;
  background: rgba($color: $neutral-1, $alpha: 0.05);
  opacity: 0.7;
  position: relative;

  & > .icon {
    position: absolute;
    color: #323232;
    font-size: 25px;
  }

  &:hover {
    opacity: 1;
    background: rgba($color: $neutral-1, $alpha: 0.15);
  }
}
</style>


// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/KIconButton.vue